import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 283.46 283.46"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("title", {
                children: "Vodafone logo"
            }),
            /*#__PURE__*/ _jsxs("g", {
                "data-name": "<Group>",
                children: [
                    /*#__PURE__*/ _jsx("circle", {
                        "data-name": "<Path>",
                        cx: 141.73,
                        cy: 141.73,
                        r: 141.73,
                        fill: "#e60000"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        "data-name": "<Path>",
                        d: "M142.83 220.77c-38.94.13-79.46-33.11-79.63-86.48-.09-35.29 18.95-69.26 43.29-89.46 23.74-19.66 56.26-32.27 85.76-32.37 3.8 0 7.77.3 10.2 1.13-25.79 5.35-46.32 29.35-46.23 56.58a14.78 14.78 0 0 0 .17 2.31c43.16 10.51 62.75 36.55 62.87 72.58s-28.32 75.55-76.43 75.71z",
                        fill: "#fff"
                    })
                ]
            })
        ]
    }));
};
export default /*#__PURE__*/ memo(SvgComponent);
